import React from 'react';
import { IndexRoute, Route, browserHistory } from 'react-router';

import CoreLayout from '../layouts/CoreLayout/CoreLayout';
import AppLayout from '../layouts/AppLayout/AppLayout';
import Home from './Home/components/HomeView';
import Login from './Login/components/Login';
import PasswordReset from './PasswordReset/components/PasswordReset';
import Company from './Company/containers/CompanyContainer';
import CompanyDetail from './CompanyDetail/containers/CompanyContainer';
import Activity from './Activity/containers/ActivityContainer';
import ActivityDetail from './ActivityDetail/containers/ActivityContainer';
import Person from './Person/containers/PersonContainer';
import PersonDetail from './PersonDetail/containers/PersonContainer';
import PersonImporter from './PersonImporter/containers/PersonImporterContainer';
import Staff from './Staff/containers/StaffContainer';
import StaffDetail from './StaffDetail/containers/StaffContainer';
import User from './User/containers/UserContainer';
import Project from './Project/containers/ProjectContainer';
import ProjectDetail from './ProjectDetail/containers/ProjectContainer';
import File from './File/containers/FileContainer';
import ServiceKey from './ServiceKey/containers/ServiceKeyContainer';
import NumberRange from './NumberRange/containers/NumberRangeContainer';
import Invitation from './Invitation/components/Invitation';
import Recovery from './Recovery/containers/RecoveryContainer';
import logActivity from '../helpers/logActivity';
import LoginWithToken from './LoginWithToken/components/LoginWithToken';
import App from './App/components/App';

browserHistory.listen(location => {
  logActivity('navigation', 'to', location.pathname);
});

export const createRoutes = store => (
  <Route path="/" component={CoreLayout}>
    <IndexRoute component={Login} />

    <Route component={Login} path="login" />

    <Route component={App} path="app" />

    <Route component={Invitation} path="invitation/:token" />

    <Route component={LoginWithToken} path="loginWithToken/:token" />

    <Route component={AppLayout}>
      <Route component={Home} path="dashboard" />
      <Route component={PasswordReset} path="password/reset/:token/:email" />

      <Route component={Company} path="company" />
      <Route component={CompanyDetail} path="company/:company" />

      <Route component={Activity} path="activity" />
      <Route component={ActivityDetail} path="activity/:activity" />

      <Route component={PersonImporter} path="person/import" />
      <Route component={Person} path="person" />
      <Route component={PersonDetail} path="person/:person" />

      <Route component={Staff} path="staff" />
      <Route component={StaffDetail} path="staff/:staff" />

      <Route component={User} path="user" />

      <Route component={Project} path="project" />
      <Route component={ProjectDetail} path="project/:project" />

      <Route component={File} path="file" />
      <Route component={ServiceKey} path="servicekey(/:servicekey)" />
      <Route component={NumberRange} path="numberrange(/:numberrange)" />

      <Route component={Recovery} path="recovery" />
    </Route>
  </Route>
);

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js